import * as d3 from "d3";


import {
    // axisTextDim1,
    colonAnnotation, contextMenu,
    createTooltip, generateDownloadData,
    inrFormatter,
    numberFormat,
    responsivefy,
    // XaxisAttribute
} from '../functions'

export default function (chart, divId, vizName, resData,filterParam) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId).append('svg')
        .attr('width', chart.width + chart.margin.left + chart.margin.right)
        .attr('height', chart.height + chart.margin.top + 2 * chart.margin.bottom)
        .call(responsivefy)
        .append('g')
        .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

    var x1Scale = d3.scaleLinear().range([0, chart.width])
    var y1Scale = d3.scaleBand()
        .range([chart.height, 0])
        .paddingInner(0.25)
        .paddingOuter(0.15);
    var x1AxisLabel = d3.axisBottom(x1Scale).ticks(8).tickFormat(numberFormat)
    // var y1AxisLabel = d3.axisLeft(y1Scale)

    function truncate(text, maxLength) {
        return text.length > maxLength
            ? text.slice(0, maxLength) + '…'
            : text;
    }


    // axios.post(url, filterParam).then(res => {
        let data = resData

        data.sort((a, b) => {
            return a.metric1 - b.metric1
        })

        x1Scale.domain([0, d3.max(data, (d) => {
            return d.metric1
        })])
        y1Scale.domain(data.map((d) => {
            return d.dim1_name
        })).paddingInner(0.3)

        svg.append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + chart.height + ')')
            .call(x1AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)

    svg.append('g')
        .attr('class', 'y axis')
        .call(
            d3.axisLeft(y1Scale)
                .tickSize(0)
                .tickPadding(10)
        )
        .selectAll('text')
        .style('font-size', axisLabelFontSize)
        .style('text-anchor', 'end');


    svg.append('text')
            .attr('x', (chart.width / 3))
            .attr('y', chart.height + chart.margin.bottom + 2 * chart.axisLabelDistance)
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', fontSize - 6)

        svg.append('text')
            .attr('x', (chart.width / 2))
            .attr('y', 0 - (chart.margin.top / 2))
            .attr('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.x2AxisDisplayName)
            .style('font-size', fontSize - 6)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left)
            .attr('x', 0 - (chart.height / 3))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', fontSize)


    svg.select('.y.axis')
        .selectAll('text')
        .text(d => truncate(d, 14))
        .append('title')   // tooltip
        .text(d => d);


    /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element
         var y1tip = tooltip_class()

         y1tip.attr('class', 'd3-tip'+divId.id).html((d) =>{
                return d.dim1_name+ colonAnnotation+ numberFormat(d.metric1)
        })

        svg.call(y1tip);*/

        const tooltip = createTooltip(divId);

        svg.selectAll('.bar')
            .data(data)
            .enter()
            .append('rect')
            .attr('height', y1Scale.bandwidth())
            .attr('y', d => {
                return y1Scale(d.dim1_name)
            })
            .attr('width', d => {
                return x1Scale(d.metric1)
            })
            .style('fill', d => {
                return (d.colorClass == 'top' ? chart.vizSpecific4 : chart.vizSpecific5)
            })
            .on("mouseover", function(d) {
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return d.dim1_name + colonAnnotation + inrFormatter(d.metric1)
                });  // Pass the event for positioning
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on("mouseout", function() {
                // Hide the tooltip on mouse out
                tooltip.onMouseLeave();
            })
            .on('contextmenu', function(d) {

                // Prepare clickedData with both axes' info
                const clickedData = {
                    [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.dim1_name]               // e.g., "metric1"
                };
                console.log("clickedData",clickedData);
                // Generate the menu with current config and filters
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                // Show the context menu
                contextMenu(menuItems).call(this, clickedData);

                // Prevent default context menu
                d3.event.preventDefault();
            });

        svg.selectAll('text.bar')
            .data(data)
            .enter()
            .append("text")
            .attr("class", ".bar")
            .attr("y", (d) => {
                return y1Scale(d.dim1_name) + y1Scale.bandwidth() / 2 + 6
            })
            .attr("x", (d) => {
                return x1Scale(d.metric1)
            })
            .text((d) => {
                return inrFormatter(d.metric1)
            })
            .style("fill", "black")
            .style("font-size", ((chart.axisLabelFontSize - 5) + "px"));
    // })
}